import React from 'react';
import { Icon } from '@/components/Icon';
import './originals-controls.css';

const walletNames = { coins: 'PCOINS', cash: 'PCASH', bonus: 'BONUS' };

export function OriginalsPrimaryButton({ className = '', ...props }) {
  return <button type="button" {...props} className={`originals-primary ${className}`} />;
}

export function OriginalsControls({ as: Panel = 'aside', game, action, hint, children, className = '', ...props }) {
  return <Panel {...props} className={`controls originals-controls ${className}`} data-original-controls>
    <div className="originals-control-heading"><strong><i />Manual play</strong><span>{game}</span></div>
    {children}
    <div className="originals-control-action">{action}{hint && <p className="originals-action-hint">{hint}</p>}</div>
  </Panel>;
}

// The caller retains its validation, limits, locks and input handlers.
export function OriginalsWager({ input, half, double, presets, hint, currency, label = 'Bet amount', disabled }) {
  const stepper = (button, key) => React.cloneElement(button, { key, type: 'button', className: 'originals-wager-step' });
  return <fieldset className="originals-wager" disabled={disabled}>
    <div className="originals-field-heading"><label htmlFor={input.props.id}>{label}</label><span>{walletNames[currency]}</span></div>
    <div className="originals-wager-field"><Icon name={currency === 'coins' ? 'pnrcoin' : 'pnrcash'} size={18} />
      {React.cloneElement(input, { className: 'originals-wager-input' })}
      <div className="originals-wager-steps">{stepper(half, 'half')}{stepper(double, 'double')}</div>
    </div>
    {presets && <div className="originals-wager-presets">{presets}</div>}{hint}
  </fieldset>;
}

export function OriginalsReturn({ label, detail, amount, children }) {
  return <div className="originals-return"><div className="originals-return-heading"><span>{label}</span><span>{detail}</span></div>
    <div className="originals-return-amount">{amount}</div><div className="originals-return-footer">{children}</div>
  </div>;
}

function mobileActions(node) {
  return React.Children.map(node, child => {
    if (!React.isValidElement(child)) return child;
    const testid = child.props['data-testid'];
    return React.cloneElement(child, {
      ...(child.props.id ? { id: `${child.props.id}-mobile` } : {}),
      ...(testid && !testid.includes('-stage-') ? { 'data-testid': `${testid}-mobile` } : {}),
      ...(child.props.children ? { children: mobileActions(child.props.children) } : {}),
    });
  });
}

// Mobile actions occupy a real row after the playing field and share its controller.
export function OriginalsMobileAction({ currency, wager, masked, children }) {
  return <div className="originals-mobile-action" role="group" aria-label="Game actions">
    <div className="originals-mobile-wager"><span>Wager · {walletNames[currency]}</span><strong><Icon name={currency === 'coins' ? 'pnrcoin' : 'pnrcash'} size={16} /><span>{masked ? '•••••' : wager}</span></strong></div>
    <div className="originals-mobile-buttons">{mobileActions(children)}</div>
  </div>;
}
